import React from 'react';

const Skills = () => {
  const skillsData = {
    technical: [
      "HTML5", "CSS3", "JavaScript", "Python", "React", "Responsive Design", 
      "Digital Marketing", "SEO/SEM", "Data Analytics", "UI/UX Design",
      "Git/GitHub", "Web Performance Optimization"
    ],
    marketing: [
      "Digital Strategy", "Social Media Marketing", "Content Marketing", 
      "Email Marketing", "Analytics & Reporting", "Campaign Management",
      "Brand Development", "Lead Generation"
    ],
    soft: [
      "Public Speaking", "Team Leadership", "Problem Solving", 
      "Time Management", "Creative Thinking", "Strategic Planning",
      "Communication", "Project Management"
    ]
  };

  return (
    <section id="skills" className="section">
      <div className="container">
        <h2 className="section-title">Skills</h2>
        <div className="skills-grid">
          <div className="skills-category">
            <h3 className="skills-category-title">Technical Skills</h3>
            <div className="skills-list">
              {skillsData.technical.map((skill, index) => (
                <span key={index} className="skill">{skill}</span>
              ))}
            </div>
          </div>
          <div className="skills-category">
            <h3 className="skills-category-title">Marketing Skills</h3>
            <div className="skills-list">
              {skillsData.marketing.map((skill, index) => (
                <span key={index} className="skill">{skill}</span>
              ))}
            </div>
          </div>
          <div className="skills-category">
            <h3 className="skills-category-title">Soft Skills</h3>
            <div className="skills-list">
              {skillsData.soft.map((skill, index) => (
                <span key={index} className="skill">{skill}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;